import React, {useMemo, useState} from "react"

import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Dialog} from "../../../../designSystem/components/Dialog";

import {ProfileEditForm} from "../ProfileEditForm";
import {ProfileEditModalContent} from "../ProfileEditModalContent";

import {useProfileEdit} from "../../hooks/useProfileEdit";
import {validateProfileEditForm} from "../../model/validateProfileEditForm";

type ProfileEditFormData = {
  name: string;
  gender: string;
  region: string;
  yearRoc: string;
  month: string;
  day: string;
  weightKg: string;
  heightCm: string;
  isIndigenous: boolean;
};

const initialFormData: ProfileEditFormData = {
  name: '',
  gender: '',
  region: '',
  yearRoc: '',
  month: '',
  day: '',
  weightKg: '',
  heightCm: '',
  isIndigenous: false,
};

export const ProfileEditFeature = ({ guest, lineUserId, onRefreshData }) => {
  const [formData, setFormData] = useState<ProfileEditFormData>(initialFormData)

  const onChangeFormData = (patch) => {
    setFormData(prev => ({ ...prev, ...patch }));
  }
  const isSubmitValid = useMemo(() => {
    return validateProfileEditForm(formData)
  }, [formData])

  const { dialogContent, submit, onConfirmEdit } = useProfileEdit({
    formData,
    setFormData,
    guest,
    lineUserId,
  })

  const onClickSaveConfirm = async () => {
    onConfirmEdit();
    await onRefreshData();
  }

  return (
    <React.Fragment>
      <div className="flex flex-1 flex-col justify-between">
        <ProfileEditForm
          formData={formData}
          onChange={onChangeFormData}
        />
        <div className="p-4">
          <ActionButton
            fullWidth
            disabled={!isSubmitValid}
            onClick={submit}
            iconName="fa-save"
            label="儲存"
          />
        </div>
      </div>
      <Dialog isOpen={dialogContent !== ''}>
        {ProfileEditModalContent({
          onClickSaveConfirm
        })[dialogContent] || <></>}
      </Dialog>
    </React.Fragment>
  )
}
